<div class="wrapper">
  <app-control-forms-details #controlFormsDetails [data]="data" />
  <app-actions-section
    [disableAddMenu]="disableAddMenu"
    [hideLocationOption]="controlFormsDetails.displayStationRange"
    class="actions-section w-[455px]"
  />
</div>
